export const FEEDBACK_BOARD_TAB = {
  HDQT: 'hdqt',
  DELEGATE: 'ndd',
}

export const FEEDBACK_BOARD_TYPE = {
  HDQT: 'HDQT',
  DELEGATE: 'NĐD',
}

const NDD_MARKER = '-NĐD'

const normalizeText = value => (value || '').toString().trim()

const normalizeBoardType = boardType => {
  const normalized = normalizeText(boardType).toLowerCase()

  if (!normalized) {
    return null
  }

  if (
    ['ndd', 'delegate', 'nguoi-dai-dien', 'nguoi_dai_dien'].includes(normalized)
  ) {
    return FEEDBACK_BOARD_TYPE.DELEGATE
  }

  if (['hdqt', 'hđqt'].includes(normalized)) {
    return FEEDBACK_BOARD_TYPE.HDQT
  }

  return null
}

export const isDelegateFeedbackTab = tab =>
  normalizeText(tab).toLowerCase() === FEEDBACK_BOARD_TAB.DELEGATE

export const getBoardTypeByTab = tab =>
  isDelegateFeedbackTab(tab)
    ? FEEDBACK_BOARD_TYPE.DELEGATE
    : FEEDBACK_BOARD_TYPE.HDQT

export const getFeedbackTabFromRouteParam = routeParam => {
  const normalizedBoardType = normalizeBoardType(routeParam)
  return normalizedBoardType === FEEDBACK_BOARD_TYPE.DELEGATE
    ? FEEDBACK_BOARD_TAB.DELEGATE
    : FEEDBACK_BOARD_TAB.HDQT
}

export const getFeedbackTabByBoardType = boardType => {
  const normalizedBoardType = normalizeBoardType(boardType)
  return normalizedBoardType === FEEDBACK_BOARD_TYPE.DELEGATE
    ? FEEDBACK_BOARD_TAB.DELEGATE
    : FEEDBACK_BOARD_TAB.HDQT
}

export const getTabByStoredDocumentNumber = documentNumber => {
  const normalized = normalizeText(documentNumber).toUpperCase()

  if (
    normalized.endsWith(NDD_MARKER) ||
    normalized.includes('/PLYK-NĐD') ||
    normalized.includes('PLYK-NĐD')
  ) {
    return FEEDBACK_BOARD_TAB.DELEGATE
  }

  return FEEDBACK_BOARD_TAB.HDQT
}

export const getFeedbackTabFromData = ({ boardType, documentNumber } = {}) => {
  const normalizedBoardType = normalizeBoardType(boardType)
  if (normalizedBoardType) {
    return getFeedbackTabByBoardType(normalizedBoardType)
  }

  return getTabByStoredDocumentNumber(documentNumber)
}

export const getFeedbackTabFromRecord = record => {
  if (!record) {
    return FEEDBACK_BOARD_TAB.HDQT
  }

  return getFeedbackTabFromData({
    boardType: record.boardType || record.board_type,
    documentNumber: record.documentNumber || record.document_number,
  })
}

export const getPlykSuffixByTab = tab =>
  isDelegateFeedbackTab(tab) ? 'PLYK-NĐD' : 'PLYK-HĐQT'

export const toDisplayDocumentNumber = documentNumber =>
  normalizeText(documentNumber)
    .replace(/\/\s*PLYK-[^/\s]+\s*$/i, '')
    .replace(/-NĐD$/i, '')

export const toStorageDocumentNumberByTab = (documentNumber, tab) => {
  const normalized = normalizeText(documentNumber)
    .replace(/\/\s*PLYK-[^/\s]+\s*$/i, '')
    .replace(/-NĐD$/i, '')
    .trim()

  if (isDelegateFeedbackTab(tab)) {
    return normalized ? `${normalized}${NDD_MARKER}` : normalized
  }

  return normalized
}
